<div class="st-page">
  <div class="st-page-head">
    <div class="sf-monthly-title-row">
      <button type="button" class="sf-back-btn" (click)="goBack()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ 'staffFeesCollection' | translate }}</h1>
        <p class="st-subtitle">{{ month }}</p>
      </div>
    </div>
  </div>

  <!-- Late fees toggle — hidden entirely while loading -->
  <div class="sf-late-fees-row" *ngIf="!fetchingData">
    <span class="sf-late-fees-label">{{ 'lateFees' | translate }}</span>
    <button type="button" class="sf-switch" [class.on]="applyLateFees" (click)="toggleLateFees()">
      <span class="sf-switch-knob"></span>
    </button>
  </div>

  <!-- Trend chart -->
  <div class="st-card sf-chart-card">
    <div class="sf-chart-head">
      <h3 class="st-card-title">{{ 'dailyCollection' | translate }}</h3>
      <button type="button" class="sf-graph-toggle" (click)="toggleGraph()">
        <i [ngClass]="openGraph ? 'ri-line-chart-fill' : 'ri-line-chart-line'"></i>
      </button>
    </div>

    <div class="sf-skeleton-chart" *ngIf="fetchingData"></div>

    <ng-container *ngIf="!fetchingData">
      <div class="sf-chart-with-axis" *ngIf="openGraph && feesData.length">
        <div class="sf-y-axis" [style.height.px]="chartHeight">
          <span *ngFor="let label of yAxisLabels">{{ currencySymbol }}{{ label }}</span>
        </div>

        <div class="sf-chart-scroll">
          <div class="sf-chart-svg-wrap" [style.width.px]="chartWidth" [style.height.px]="chartHeight">
            <svg
              class="sf-line-chart"
              [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight"
              [attr.width]="chartWidth"
              [style.height.px]="chartHeight"
              preserveAspectRatio="xMinYMid meet"
            >
              <polyline
                [attr.points]="chartLinePoints"
                fill="none" stroke="url(#sfDailyLineGradient)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <circle
                *ngFor="let p of chartPoints"
                [attr.cx]="p.x" [attr.cy]="p.y" r="4"
                fill="#fff" stroke="#37B904" stroke-width="2"
                class="sf-chart-dot"
              >
                <title>{{ p.paymentDate }}: {{ formatAmount(p.amount) }}</title>
              </circle>
              <defs>
                <linearGradient id="sfDailyLineGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stop-color="#37B904" />
                  <stop offset="100%" stop-color="var(--brand-primary-color)" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="sf-line-labels" [style.width.px]="chartWidth">
            <span *ngFor="let p of chartPoints" [style.width.px]="chartWidth / chartPoints.length">{{ p.label }}</span>
          </div>
        </div>
      </div>

      <p class="sf-empty" *ngIf="!feesData.length">{{ 'noDataAvailable' | translate }}</p>
    </ng-container>
  </div>

  <!-- Day tiles — not tappable, no further drill-down -->
  <div class="st-card sf-months-card">
    <h3 class="st-card-title">{{ 'dailyCollection' | translate }}</h3>

    <div class="sf-month-grid" *ngIf="fetchingData">
      <div class="sf-month-tile sf-month-tile-skeleton" *ngFor="let s of skeletonTiles"></div>
    </div>

    <ng-container *ngIf="!fetchingData">
      <div class="sf-month-grid" *ngIf="feesData.length">
        <div class="sf-month-tile sf-day-tile" *ngFor="let d of feesData">
          <span class="sf-month-tile-label">{{ d.paymentDate }}</span>
          <span class="sf-month-tile-amount">{{ formatAmount(dayAmount(d)) }}</span>
        </div>
      </div>

      <p class="sf-empty" *ngIf="!feesData.length">{{ 'noDataAvailable' | translate }}</p>
    </ng-container>
  </div>
</div>
